import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { deleteVendor, getVendorData, updateVendor } from "./Vendor.action";
import { setHeading } from "../../../accounts/account.actions";
import { useEffect } from "react";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from 'material-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewVendor = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"))
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some(p => p[`${permissionsType}`] === permissionsName) ? false : true
  }

  useEffect(() => {
    props.setHeading("Vendor List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          title="Vendor List"
          columns={[
            { title: 'S.N0', field: 'sequenceNumber', editable: 'never' },
            { title: 'Vendor Name', field: 'vendorName' },
            { title: 'Vendor Phone', field: 'vendorPhone' },
            { title: 'Vendor CNIC', field: 'vendorCnic' },
            { title: 'Vendor Address', field: 'vendorAddress' },
            { title: 'Vendor Type', field: 'vendorType', editable: 'never' },
            { title: 'Company', field: 'company' },
            { title: "Created By", field: "userDetails.userName", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/vendor/get-vendors?`;
              url += "size=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: 'GET',
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "potrait";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Vendor Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((rowData) => [
                rowData.sequenceNumber,
                rowData.vendorName,
                rowData.vendorPhone,
                rowData.vendorCnic,
                rowData.vendorAddress,
                rowData.vendorType,
                rowData.company,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Vendor Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            isEditHidden: rowData => Checkpermissions("permissionsSubCatName", "Vendor Edit"),
            isDeleteHidden: rowData => Checkpermissions("permissionsSubCatName", "Vendor Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.updateVendor(newData, oldData)
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteVendor(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getVendorData: () => dispatch(getVendorData()),
    deleteVendor: (vendorId) => dispatch(deleteVendor(vendorId)),
    updateVendor: (newData, oldData) => dispatch(updateVendor(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  vendorDataList: state.VendorReducer.vendorDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewVendor);
